import { type FC, useState } from "react"

import { type PersonalizedVideo } from "@forento/core/models/video"
import { toPriceString } from "@forento/core/utilities/currency"

import { usePlatform } from "~/contexts/UserContext"
import trpc from "~/utilities/trpc"

import { AccessButton, containerClasses, Tag, tagsClasses, titleClasses } from "./shared"

type Props = { video: PersonalizedVideo; userId: number; reload(): Promise<unknown> }
const Video: FC<Props> = ({ video, userId, reload }) => {
	const hasAssignProductAccess = usePlatform()!.plan.access.assignProducts

	const [isSubmittingAccess, setSubmittingAccess] = useState(false)

	async function handleGiveAccess() {
		setSubmittingAccess(true)
		try {
			await trpc.product.giveManualAccess.mutate({ product: { type: "video", id: video.id }, userId })
			await reload()
		} catch (error) {
			console.error(error)
			setSubmittingAccess(false)
		}
		setSubmittingAccess(false)
	}

	async function handleRemoveAccess() {
		setSubmittingAccess(true)
		try {
			await trpc.product.removeManualAccess.mutate({ product: { type: "video", id: video.id }, userId })
			await reload()
		} catch (error) {
			console.error(error)
			setSubmittingAccess(false)
		}
		setSubmittingAccess(false)
	}

	return (
		<div className={containerClasses}>
			<h3 className={titleClasses}>{video.name}</h3>
			<div className={tagsClasses}>
				{video.status === "unlocked" ? (
					<>
						{video.unlockedCause === "purchased" &&
							video.order.type === "external" &&
							video.order.createdBy === "manual" && (
								<AccessButton isDanger onClick={handleRemoveAccess} isLoading={isSubmittingAccess}>
									Remove access
								</AccessButton>
							)}
						<Tag color="orange">Unlocked</Tag>
						{video.unlockedCause === "purchased" ? (
							video.order.type === "external" ? (
								video.order.createdBy === "zapier" ? (
									<Tag color="blue">Purchased through Zapier</Tag>
								) : (
									<Tag color="blue">Manual access</Tag>
								)
							) : (
								<Tag color="blue">Purchased</Tag>
							)
						) : video.unlockedCause === "membership" ? (
							<Tag color="blue">Membership</Tag>
						) : null}
					</>
				) : (
					hasAssignProductAccess && (
						<AccessButton onClick={handleGiveAccess} isLoading={isSubmittingAccess}>
							Give access
						</AccessButton>
					)
				)}
				<Tag color="green">
					{video.isManualOnly
						? "Manual only"
						: video.price !== null
							? toPriceString(video.price)
							: video.membershipIds.length > 0
								? "Membership"
								: "Free"}
				</Tag>
			</div>
		</div>
	)
}

export default Video
